import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";

const TransferForm = ({ seatNumber }) => {
  const { chatData, refreshChatData, refreshUserData, validateEcode } =
    useAuth();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [emailOrMobile, setEmailOrMobile] = useState("");
  const [note, setNote] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const realNum = Array.isArray(seatNumber)
    ? seatNumber.filter((num) => !isNaN(num)).join(",")
    : "";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch(
        "https://kracet.shop/mastapi/transferapi.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            first_name: firstName,
            last_name: lastName,
            email: emailOrMobile,
            note: note,
            chat_id: chatData?.chat_id,
            realNum: realNum,
          }),
        }
      );

      const result = await response.json();

      if (result.success) {
        alert("Transfer successful!");
        refreshChatData();
        refreshUserData();
        validateEcode();
      } else {
        alert("Transfer failed: " + result.message);
      }
    } catch (error) {
      console.error("Error Making Transfer:", error);
      alert("Error during transfer");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <p className="font-semibold text-md">First Name</p>
        <input
          type="text"
          required
          placeholder="First Name"
          className="w-full h-10 bg-gray-100 border border-gray-700 rounded-sm px-2 mt-1"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
      </div>

      <div>
        <p className="font-semibold text-md">Last Name</p>
        <input
          type="text"
          required
          placeholder="Last Name"
          className="w-full h-10 bg-gray-100 border border-gray-700 rounded-sm px-2 mt-1"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />
      </div>

      <div>
        <p className="font-semibold text-md">Email or Mobile Number</p>
        <input
          type="email"
          required
          placeholder="Email or Mobile Number"
          className="w-full h-10 bg-gray-100 border border-gray-700 rounded-sm px-2 mt-1"
          value={emailOrMobile}
          onChange={(e) => setEmailOrMobile(e.target.value)}
        />
      </div>

      <div>
        <p className="font-semibold text-md">Note</p>
        <textarea
          rows={3}
          required
          placeholder="Note"
          className="w-full h-24 bg-gray-100 border border-gray-700 rounded-sm px-2 mt-1"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
      </div>

      <div>
        <button
          type="submit"
          className="bg-blue-600 px-4 py-2 rounded-lg text-white flex items-center justify-center"
          disabled={isLoading}
        >
          {isLoading ? (
            <svg
              className="animate-spin h-5 w-5 mr-2 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v8z"
              ></path>
            </svg>
          ) : null}
          {isLoading ? "Transferring..." : "Transfer"}
        </button>
      </div>
    </form>
  );
};

export default TransferForm;
